class Cookie {
  constructor(name, value) {
    this.name = name;
    this.value = value;
    this.expiration = this.createExpiration();
  }

  get cookieString() {
    return this.createCookieString();
  }

  createCookieString() {
    let cookieString = `${this.name}=${this.value};expires=${this.expiration};path=/`;

    return cookieString;
  }

  createExpiration() {
    let cookieExpiration = new Date();
    cookieExpiration.setHours(cookieExpiration.getHours() + 24);

    return cookieExpiration.toUTCString();
  }

  static createCookie(content) {
    document.cookie = content;
  }
}

$(() => {
  var globalAlertPlaceholder = $(".js-global-alert");

  if (!globalAlertPlaceholder.length) {
    return;
  }

  var language = document.documentElement.lang;

  $.ajax({
    url: "/api/globalalert/",
    data: { languageCode: language },
    success: function (data) {
      if (data !== null && data !== "") {
        globalAlertPlaceholder.html(data);
        globalAlertPlaceholder.collapse("show");

        $('[data-global-alert-button="close"]').click((e) => {
          let name = e.currentTarget.dataset.globalAlertCookieName;
          let id = e.currentTarget.dataset.globalAlertId;
          removeGlobalAlert(name, id);
        });
      }
    },
  });
});

function removeGlobalAlert(cookieName, cookieContent) {
  const cookie = new Cookie(cookieName, cookieContent);
  Cookie.createCookie(cookie.cookieString);
}
